import React from 'react';
import Navigation from '../components/Navigation';
import { Mail } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <Navigation />
      
      {/* Header */}
      <div className="bg-gray-50 border-b border-gray-100 pt-20">
        <div className="max-w-3xl mx-auto px-6 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Contact</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="prose prose-gray max-w-none">
          <p className="text-gray-600 leading-relaxed mb-8">
            For general inquiries, partnerships, or questions:
          </p>
          
          <a 
            href="mailto:priyanshu@xerobrain.com"
            className="inline-flex items-center gap-3 px-6 py-4 rounded-xl bg-gray-50 border border-gray-200 hover:border-[#002699]/30 hover:bg-[#002699]/5 transition-all group"
          >
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#002699] to-[#E62020] flex items-center justify-center">
              <Mail className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-medium text-gray-900 group-hover:text-[#002699] transition-colors">
              priyanshu@xerobrain.com
            </span>
          </a>
          
          <p className="text-gray-500 mt-8 text-sm">
            We typically reply within 1–2 business days.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
